import axios, { type AxiosInstance } from "axios";
import { setLogOut } from "../../auth/actions/logout.actions";
import { loginCookies } from "../../shared/utils/auth";
import { appStore } from "../../store";
import {
  accessTokenCookieName,
  baseUrl,
  refreshTokenCookieName,
} from "../config";
import { storage } from "./storage";

const REFRESH_TOKEN_ENDPOINT = `${baseUrl}/api/auth/participant/refresh-token`;

const logout = (err) => {
  appStore.dispatch(setLogOut());

  storage.delete("widget");
  loginCookies.remove(accessTokenCookieName);
  loginCookies.remove(refreshTokenCookieName);

  window.location.replace("/"); //use history when http is converted to a hook
  return Promise.reject(err);
};

const http: AxiosInstance = axios.create();

http.interceptors.request.use((req) => {
  const token = loginCookies.get(accessTokenCookieName);
  req.headers.authorization = `Bearer ${token}`;
  return req;
});

http.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (originalRequest.url === REFRESH_TOKEN_ENDPOINT) return logout(error);

    if (error.response.status === 401) {
      if (originalRequest.retry) return logout(error);

      originalRequest.retry = true;

      const accessToken = loginCookies.get(accessTokenCookieName);
      const refreshToken = loginCookies.get(refreshTokenCookieName);

      const refreshResponse = await http.post(REFRESH_TOKEN_ENDPOINT, {
        accessToken,
        refreshToken,
      });

      const data = refreshResponse?.data?.data;
      loginCookies.set(accessTokenCookieName, data?.accessToken);
      loginCookies.set(refreshTokenCookieName, data?.refreshToken);

      originalRequest.headers.authorization = `Bearer ${data?.accessToken}`;

      return http(originalRequest);
    }

    return Promise.reject(error);
  }
);

export { http };
